//******************* CASES ********************\\
export const FETCHING_MODULES = "FETCHING_MODULES";
export const FETCHING_MODULE = "FETCHING_MODULE";
export const GET_MODULES_SUCCESS = "GET_MODULES_SUCCESS";
export const GET_MODULES_ERROR = "GET_MODULES_ERROR";
export const GET_MODULE_SUCCESS = "GET_MODULE_SUCCESS";
export const GET_MODULE_ERROR = "GET_MODULE_ERROR";
